<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12 col-md-6 mx-auto pe-5">
        <h1 class="text-start" v-if="currentStep == 0">Välj tjänst</h1>
        <select class="form-control mb-4" v-model="formkey" v-if="currentStep == 0">
          <option value="movingHelpAndMovingCleaning">Flytthjälp och Flyttstädning</option>
          <option value="movingCleaning">Flyttstädning</option>
          <option value="movingHelp">Flytthjälp</option>

          <option value="homeCleaning">Hemstädning</option>
          <option value="bigCleaning">Storstädning</option>
          <option value="windowCleaning">Fönsterputs</option>
          <option value="kontorsflytt">Kontorsflytt</option>
          <option value="officeCleaning">Kontorsstädning</option>
          
          <option value="manualWorkHelp">Hantverkshjälp</option>
          <option value="heavyLift">Tunga lyft</option>
          <option value="sanering">Sanering</option>
          <option value="bortforsling">Bortforsling</option>
          <option value="packhjalp">Packhjälp</option>
    
          <option value="constructionCleaning">Byggstädning</option> 
        </select>
        <!-- <p class="text-start">Låt oss hjälpa med att föra ditt hem och din beliv</p> -->
        <template v-if="(!email || !name || !phone) && currentStep == 0">
          <label for="name" class="form-label">Namn *</label>
          <input type="text" id="name" class="form-control mb-4" v-model="formData.wpname" />

          <label for="phone" class="form-label">Telefon *</label>
          <input type="text" id="phone" class="form-control mb-4" v-model="formData.wpphone" />

          <label for="email" class="form-label">E-mail *</label>
          <input type="email" id="email" class="form-control mb-4" v-model="formData.wpemail" />
        </template>

        <div v-for="(step, index) in currentForm.steps" :key="index">
          <div v-if="currentStep === index">
            <h2 class="mb-3">{{ step.title }}</h2>
            <question-component
              v-for="question in step.questions"
              :key="question.id"
              :question="question"
              @input="setFormData(question.id, $event)"
            />
          </div>
        </div>
        
        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-secondary" @click="prevStep" :disabled="currentStep === 0">Tillbaka</button>
          <button class="btn btn-dark" @click="nextStep" v-if="currentStep < currentForm.steps.length - 1">Fortsätt</button>
          <button class="btn btn-success" v-else @click="submitForm">Skicka</button>
        </div>
        <div class="mt-2" v-if="currentStep == currentForm.steps.length - 1">
          
          <input class="form-check-input" type="checkbox" id="consent" name="consent" @change="consent = !consent" />
          <label class="form-check-label mx-2" for="consent"> Klicka i för att godkänna våra <a href="/gdpr">GDPR villkor</a></label>
        </div>
      </div>
      <summary-component :form-data="formData" :form-config="currentForm" class="mt-4" />
    </div>
  </div>
</template>

<script>
//import formConfig from '../assets/formConfig.json';
import bigCleaning from '../assets/bigCleaning.json';
import homeCleaning from '../assets/homeCleaning.json';
//import gardenHelp from '../assets/gardenHelp.json';
import constructionCleaning from '../assets/constructionCleaning.json';
import manualWorkHelp from '../assets/manualWorkHelp.json';
import heavyLift from '../assets/heavyLift.json';
import movingCleaning from '../assets/movingCleaning.json';
import movingHelpAndMovingCleaning from '../assets/movingHelpAndMovingCleaning.json';
import windowCleaning from '../assets/windowCleaning.json';
import sanering from '../assets/sanering.json';
import packhjalp from '../assets/packhjalp.json';
import bortforsling from '../assets/bortforsling.json';
import kontorsflytt from '../assets/kontorsflytt.json';
import officeCleaning from '../assets/officeCleaning.json';
import movingHelp from '../assets/movingHelp.json';
import QuestionComponent from './QuestionComponent.vue';
import SummaryComponent from './SummaryComponent.vue';
import axios from 'axios';

const forms = {
  bigCleaning,
  homeCleaning,
  //gardenHelp,
  manualWorkHelp,
  heavyLift,
  sanering,
  bortforsling,
  packhjalp,
  kontorsflytt,
  constructionCleaning,
  movingCleaning,
  officeCleaning,
  movingHelpAndMovingCleaning,
  windowCleaning,
  movingHelp
};

export default {
  components: { QuestionComponent, SummaryComponent },
  // Remove the prop since the formkey will be set via the dropdown
  props: {
    name: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // Set a default formkey (this value will change with the dropdown)
      formkey: 'movingHelpAndMovingCleaning',
      currentStep: 0,
      consent:false,
      formData: {
        wpname: this.name,
        wpemail: this.email,
        wpphone: this.phone
      }
    };
  },
  computed: {
    // Dynamically return the configuration for the selected form
    currentForm() {
      return forms[this.formkey] || formConfig;
    }
  },
  watch: {
    // Optionally, watch for changes in formkey to reset your form if needed
    formkey(newVal, oldVal) {
      console.log('formkey changed from', oldVal, 'to', newVal);
      this.currentStep = 0;
      this.formData = {
        wpname: this.name,
        wpemail: this.email,
        wpphone: this.phone
      };
    },
    consent(newVal, oldVal){
      console.log(newVal)
    }
  },
  methods: {
    nextStep() {
      if (this.validateStep()) {
        this.currentStep++;
      }
    },
    prevStep() {
      this.currentStep--;
    },
    getLabel(id) {
      for (let step of this.currentForm.steps) {
        for (let q of step.questions) {
          if (q.id === id) return q.label.replace('*', '');
        }
      }
      if(id === "wpphone") return "Telefon";
      else if(id === "wpemail") return "E-mail";
      else if(id === "wpname") return "Namn";
      //else if(id === "service") return this.formConfig.steps[0].title;
      return id;
    },
    validateStep() {
      const currentQuestions = this.currentForm.steps[this.currentStep].questions;
      for (let q of currentQuestions) {
        if (q.required && !this.formData[q.id]) {
          alert(`Fyll i följande fält: ${q.label}`);
          return false;
        }
      }
      if (!this.formData.wpname || !this.formData.wpemail || !this.formData.wpphone) {
          alert("Fyll i namn");
          return false;
      }
      if (!this.formData.wpemail) {
          alert("Fyll i e-mail");
          return false;
      }
      if (!this.formData.wpphone) {
          alert("Fyll i telefonnummer");
          return false;
      }
      return true;
    },
    setFormData(questionId, value) {
      if (typeof value === 'object' && value !== null && value instanceof InputEvent) {}
      else if (typeof value === 'object' && value !== null) {
        console.warn(`setFormData received an object for ${questionId}:`, value);
        this.formData[questionId] = this.formatDateToYYYYMMDD(value);
      } else {
        this.formData[questionId] = value;
        console.log(`Updated ${questionId}:`, value);
      }
    },
    formatDateToYYYYMMDD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async submitForm() {
    if(!this.consent){
      alert("Godkänn villkoren för att komma vidare!");
    }
    else if (this.validateStep()) {
      try {
        let formData = new FormData();

        // Append all form data
        for (const key in this.formData) {
          formData.append(this.getLabel(key), this.formData[key]);
        }
        formData.append("service",this.currentForm.steps[0].title);
        formData.append("startDate",this.formData["startDate"]);

        // Make the request with the correct headers
        const response = await axios.post('/post-api/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        document.location = "/tack/";

        console.log(response.data);
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    }
  }
  }
};
</script>
